// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__3rJsD","content":"ErrorPage_content__wqXOf","text":"ErrorPage_text__1WsWr","image":"ErrorPage_image__1P4AW"};